import axiosInstance from "@/api/axios-instance";

export async function createNote({
  user_id,
  content,
}: {
  user_id: string;
  content: string;
}) {
  const response = await axiosInstance.post("/note", {
    user_id,
    content,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to create note");
  }

  return response.data;
}

